import React from 'react';
import PageLayout from 'components/layouts/PageLayout';
import TermsContainer from 'containers/TermsContainer';

const RulesPage = () => {
  const title = {
    ko: '체크인정보 작성',
    en: 'Check-in Information',
    ja: 'チェックイン情報',
    zh: '入住信息',
  };
  return (
    <PageLayout title="체크인정보 작성">
      <TermsContainer type="CHECKIN" title={title} />
    </PageLayout>
  );
};

export default RulesPage;
